import { render, staticRenderFns } from "./lessThan.vue?vue&type=template&id=744f428d&scoped=true&"
import script from "./lessThan.vue?vue&type=script&lang=js&"
export * from "./lessThan.vue?vue&type=script&lang=js&"
import style0 from "./lessThan.vue?vue&type=style&index=0&id=744f428d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744f428d",
  null
  
)

export default component.exports